export const fr = {
	app_name: "CITES",
	back: "Retour",
	validate: "Valider",
	cancel: "Annuler",
	add: "Ajouter",
	edit: "Modifier",
	delete: "Supprimer",
	confirm: "Confirmation",
	close: "Fermer",
	yes: "Oui",
	no: "Non",
	loading: "Chargement",
	apply: "Appliquer",
	today: "Aujourd'hui",
	remove: "Retirer",
	export: "Exporter",
	export_all: "Exporter tout",
	created_info: "Créé le {date} par {user}",
	no_result: "Aucun résultat",
	drag_file_here: "Déposer fichier votre ici !",
	drag_file_type_error: "Ce format n'est pas autorisé !",
	remove_file: "Retirer le fichier",
	default_error_message: 'Une erreur est survenue.',
    step: "Étape {0}",
    refresh_data: "Rafraîchir les données",
	error: {
		field_required: "Le champ {0} est requis",
		max_length: 'La longueur maximale de ce champ est de {0} caractères',

	},
	search: {
		results: "Résultats de la recherche",
		here: "Rechercher ici",
		search: "Rechercher",
		filter: "Filtrer",
	},
	home: {
	},
	cites: {
		add: "Ajouter un CITES",
		list: "Gestion des CITES",
		date: "Date",
		number: "Numéro",
		folderNumber: "Numéro du dossier",
		progress: "Avancement",
		tauxRetrouve: "Tx de détection",
		action: "Action",
		pdf: "PDF",
		excel: "Excel",
		cites_both_files_required: "Un fichier PDF et un fichier Excel sont requis !",
        download_logs: "Télécharger les logs",
        download_generated_file: "Télécharger le compte-rendu généré",
        delete_cites: "Supprimer le CITES",
        confirm_delete: "Etes-vous sûr de vouloir supprimer ce CITES ? Cette action est irréversible.",
        specie: "Espèce",
        action_label: {
            1 : "Erreur d'exécution",
            2 : "Patientez",
            3 : "Télécharger",
            4 : "Tags à valider",
        },
        detail: "Détail du CITES",
        go_to_detail: "Détail du CITES"
	},
    species: {
        alligator: "Alligator",
        niloticus: "Niloticus",
    },
    cites_detail: {
        header_one_page : "Page spécifique",
        header_full_pdf : "PDF entier",
    },
    result: {
        select_tag_to_review: "Sélectionner une référence",
        tag_found_pages: "La référence {0} a été trouvée sur la page {1}",
        tag_found_pages_short: "Référence trouvée page {0}",
        tag_closest_pages_short: "Référence la plus proche trouvée page {0}",
        tag_select_pages_short: "Référence sélectionnée page {0}",
        tag_unfound_pages: "La référence {0} n'a pas été trouvée",
        previous_result: "Référence précédente",
        next_result: "Référence suivante",
        ref: "Référence",
        found: "Trouvée",
        pages_found: "Numéro de la page",
        bounding_box_coordinates: "Position de la référence",
        x1: "x1",
        y1: "y1",
        x2: "x2",
        y2: "y2",
        page_n: "Page n°{0}",
        previous_page: "Page précédente",
        next_page: "Page suivante",
        pages_type: "Page de type",
        page_type_list: {
            null: "INCONNUE",
            unknown: "INCONNUE",
            import: "PERMIS",
            cites: "REFERENCE",
        },
        put_result_rectangle: "Placer la référence",
        moove_result_rectangle: "Déplacer la référence",
        put_result_rectangle_howto: "Cliquez sur le PDF, puis maintenez le clic et faites glisser pour dessiner un rectangle autour de la référence recherchée.",
        put_result_rectangle_cancel_tooltip: "Annuler le placement de référence",
        all: "Complète",
        to_find: "Partielle",
        mark_as_not_found: "Déclarer comme non trouvée",
        cancel_rectangle_change: "Annuler",
        save_result_rectangle: "Sauvegarder",
        rollback_not_found: "Réinitialiser",
        zoom_in: "Zoomer",
        zoom_reset: "Réinitialiser le zoom et le déplacement",
        zoom_out: "Dézoomer",
    },
    errors: {
        error_title: "Erreur",
        error_default: "Une erreur est survenue.",
        error_load: "Une erreur est survenue lors du chargement des données.",
        error_load_page_file: "Une erreur est survenue lors du chargement de l'aperçu de la page.",
        error_create: "Une erreur est survenue lors de la création de l'élément.",
        error_update: "Une erreur est survenue lors de la mise à jour de l'élément.",
        error_delete: "Une erreur est survenue lors de la suppression de l'élément.",
        error_download: "Une erreur est survenue lors du téléchargement du fichier.",
        files_to_big: "Vos fichiers sont trop volumineux.\nLe cumul des fichiers ne doit pas dépasser {0}.",
    },
    pages: {
        pages_selector_title: "Page n°",
    }
};
